import { ExampleFrame } from './ExampleFrame';
import { Grid } from '../ui/Layout';
import type { GridColumns } from '../ui/Layout';

// ------------------------------------------------------------------
// VariantGrid — story 2-147p (P10 §4, DOD). A grid of ExampleFrames, one
// per named variant of the SAME primitive (e.g. Button's primary/
// secondary/ghost/destructive variants, side by side) — formalizes the
// `grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4` shape the "Color
// tokens" Section and others already hand-roll for exactly this "many
// small labeled examples of one thing" layout.
//
// Story 2-147xd: composes `Grid` (`src/components/ui/Layout.tsx`, story
// 2-147sa) instead of a hand-rolled `grid`/`gap-*` className — the exact
// gap `Grid`'s own header comment names this file as evidence for.
// ------------------------------------------------------------------

export interface VariantGridItem {
  key: string;
  label: string;
  children: React.ReactNode;
}

export interface VariantGridProps {
  items: VariantGridItem[];
  /** Max columns at the widest breakpoint. Defaults to 3. */
  columns?: 2 | 3 | 4;
}

const COLUMNS: Record<2 | 3 | 4, GridColumns> = {
  2: { base: 1, sm: 2 },
  3: { base: 1, sm: 2, lg: 3 },
  4: { base: 1, sm: 2, lg: 4 },
};

export function VariantGrid({ items, columns = 3 }: VariantGridProps): JSX.Element {
  return (
    <Grid columns={COLUMNS[columns]} gap={4}>
      {items.map((item) => (
        <ExampleFrame key={item.key} label={item.label}>
          {item.children}
        </ExampleFrame>
      ))}
    </Grid>
  );
}
